module.exports = __webpack_public_path__ + "bed-temp-bg.40c37479.png";